// extracted by mini-css-extract-plugin
export default {"tableHeader":"AllPartsModal_tableHeader__Ju7iA","scrollBar":"AllPartsModal_scrollBar__Zv2ZN ScrollBar_scrollBar__FoJSw"};